<template>
  <CrudList
    label="Back-up titel"
    edit-title="Back-up aanpassen"
    add-title="Back-up toevoegen"
    type="page"
    :endpoint='uid => `/api/websites/${uid}/backups`'
    :selectable="false"
    :editable="false"
    :showDate="true"
    adderTitle="Add new backup"

    actionTitle="Reset to this backup"
    add-success-message="Websiteconfiguratie succesvol opgeslagen!"
    :confirmDelete="confirmDelete"
    :pageSize="10000"

    v-bind="$attrs"

    @action='setBackup'
  >
    <EmptyStatePlaceholder
      title="Er zijn geen back-ups"
    >
      <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
        <path d="M7.707 10.293a1 1 0 10-1.414 1.414l3 3a1 1 0 001.414 0l3-3a1 1 0 00-1.414-1.414L11 11.586V6h5a2 2 0 012 2v7a2 2 0 01-2 2H4a2 2 0 01-2-2V8a2 2 0 012-2h5v5.586l-1.293-1.293zM9 4a1 1 0 012 0v2H9V4z" />
      </svg>
    </EmptyStatePlaceholder>
  </CrudList>
</template>

<script>

import CrudList from "../../../pages/websites/WebsiteTabs/WebsiteContents/CrudList.vue"
import EmptyStatePlaceholder from "../../../layout/EmptyStatePlaceholder.vue"

export default {
  components: {
    CrudList,
    EmptyStatePlaceholder,
  },
  methods: {
    setBackup(item) {
      this.$store.commit("pushModal", {
        toBind: {
          title: "Weet je het zeker?",
          description: `Weet u zeker dat u de back-up van <b>${item.name}</b> wilt instellen? Uw huidige configuratie gaat verloren, zorg ervoor dat u er een nieuwe back-up voor maakt voordat u doorgaat.`,
          buttonSave: "Terugzetten naar " + item.name,
          callback: async () => {
            await this.axios.put(`/api/websites/${this.$route.params.id}/backups/${item.uid}`)
            this.$store.dispatch('clearCacheSearch', "websites")

            this.$success("Reset succesvol naar back-up! Bewerker opnieuw laden...")
            this.$emit('refetch-website')
          },
        },
        modal: "ConfirmAction",
      })
    },
  },
  computed: {
    confirmDelete() {
      return item => ({
        title: "Weet je het zeker?",
        description: `De back-up van <b>${item.name}</b> gaat voor altijd verloren, dit kan niet ongedaan worden gemaakt.`,
        buttonSave: `Back-up van ${item.name} verwijderen`,
      })
    },
  },
}

</script>
